import {
  Header,
  LoaderSpinner,
  ModalContent,
  Stack,
} from '@lightspeed/design-system-react'
import React, { FC, useEffect } from 'react'
import { useMutation } from '@apollo/client'
import { useT } from '@transifex/react'
import {
  REVERSE_TRANSACTION,
  ReverseTransactionData,
  ReverseTransactionInput,
  Transaction,
} from '../../queries/Transaction'
import { SwiperErrorMessage } from '../../hooks/use-swiper-payment-reducer/types'
import { useErrorMessages } from '../../hooks/useErrorMessages'

const heightStyle = { height: 200 }
interface Props {
  registerID: string
  registerSalePaymentID: string
  retailerPaymentTypeID: string
  onComplete: (transaction: Transaction) => void
  onError: (errorMessage: SwiperErrorMessage) => void
}

export const Reversing: FC<Props> = ({
  registerID,
  retailerPaymentTypeID,
  registerSalePaymentID,
  onComplete,
  onError,
}) => {
  const t = useT()
  const { getSwiperErrorMessage } = useErrorMessages()
  const onMutationComplete = (transaction: Transaction) => {
    onComplete(transaction)
  }
  const [reverseTransaction] = useMutation<
    ReverseTransactionData,
    ReverseTransactionInput
  >(REVERSE_TRANSACTION, {
    variables: {
      input: {
        registerID,
        registerSalePaymentID,
        retailerPaymentTypeID,
      },
    },
    onCompleted: data => {
      onMutationComplete(data.reverseTransaction)
    },
    onError: error => {
      onError(getSwiperErrorMessage(error))
    },
  })

  useEffect(() => {
    reverseTransaction()
  }, [reverseTransaction])

  return (
    <ModalContent className="vd-flex vd-flex--justify-center vd-flex--align-center">
      <Stack
        className="vd-flex--justify-center"
        align="center"
        style={heightStyle}
        space={5}
      >
        <LoaderSpinner />
        <Header level="1" type="heading">
          {t('Cancelling…', {
            _context: 'The message shown when cancelling a transaction',
          })}
        </Header>
      </Stack>
    </ModalContent>
  )
}
